var map = {
	"./Alpha.png": 780,
	"./Beta.png": 781,
	"./Chi.png": 782,
	"./Delta.png": 783,
	"./Epsilon.png": 784,
	"./Eta.png": 785,
	"./Gamma.png": 786,
	"./Iota.png": 787,
	"./Kappa.png": 788,
	"./Lambda.png": 789,
	"./Mu.png": 790,
	"./Nu.png": 791,
	"./Omega.png": 792,
	"./Omicron.png": 793,
	"./Phi.png": 794,
	"./Pi.png": 795,
	"./Psi.png": 796,
	"./Rho.png": 797,
	"./Sigma.png": 798,
	"./Tau.png": 799,
	"./Theta.png": 800,
	"./Upsilon.png": 801,
	"./Xi.png": 802,
	"./Zeta.png": 803
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1324;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x ^\.\/.*\.png$
// module id = 1324
// module chunks = 0